/**
 * True when the page is rendered inside a third-party iframe (?embed=1), used by
 * MijnSpaarneGasthuis to embed specialist profiles (SSG-442).
 *
 * This flag affects rendering only: it hides site chrome, suppresses analytics and
 * stops anything in the frame from writing cookies. Which paths may be framed at
 * all is decided server-side from the request path, see
 * Dotnet/EntryPoint/Middleware/EmbedOptions.cs — so this query parameter can never
 * widen what is embeddable.
 */
export const isEmbedded = (): boolean =>
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('embed') === '1'
